"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildBorderRadiusStyle = buildBorderRadiusStyle;
exports.buildBorderStyle = buildBorderStyle;
exports.buildDirectionStyle = buildDirectionStyle;

function buildDirectionStyle(attr, value) {
  return {
    [`${attr}Top`]: value,
    [`${attr}Right`]: value,
    [`${attr}Bottom`]: value,
    [`${attr}Left`]: value
  };
}

function buildBorderStyle(attr, value) {
  return {
    [`borderTop${attr}`]: value,
    [`borderRight${attr}`]: value,
    [`borderBottom${attr}`]: value,
    [`borderLeft${attr}`]: value
  };
}

function buildBorderRadiusStyle(value) {
  return {
    borderTopLeftRadius: value,
    borderTopRightRadius: value,
    borderBottomRightRadius: value,
    borderBottomLeftRadius: value
  };
}